import { useEffect, useRef } from "react";
import { spectrum } from "@/lib/equalizer";
import { beatTick } from "@/lib/beat";

const BLOBS = 6;
/* Low-res canvas of drifting rainbow blobs, blurred by CSS. Blob size swells with the band it tracks; hues drift in "flow" mode. */
export const Aurora = ({ playing = false, mode = "rainbow", className = "" }) => {
  const ref = useRef(null);
  const lv = useRef(new Array(BLOBS).fill(0.3));
  useEffect(() => {
    const cv = ref.current;
    if (!cv) return;
    cv.width = 192; cv.height = 108;
    const ctx = cv.getContext("2d");
    let raf;
    const draw = (now) => {
      const { width: w, height: h } = cv;
      ctx.clearRect(0, 0, w, h);
      const live = playing ? spectrum(BLOBS) : null;
      const beat = playing ? beatTick(now) : 0;
      const t = now / 1000;
      for (let i = 0; i < BLOBS; i++) {
        const target = live ? live[i] : playing ? 0.35 + 0.15 * Math.sin(t * 0.8 + i) : 0.2;
        lv.current[i] += (target - lv.current[i]) * (target > lv.current[i] ? 0.25 : 0.06);
        const v = lv.current[i];
        const hue = ((i / BLOBS) * 300 + (mode === "flow" ? now / 25 : 0)) % 360;
        const cx = w * (0.15 + 0.7 * (0.5 + 0.5 * Math.sin(t * (0.21 + i * 0.03) + i * 1.9)));
        const cy = h * (0.2 + 0.6 * (0.5 + 0.5 * Math.cos(t * (0.17 + i * 0.025) + i * 1.3)));
        const r = h * (0.28 + v * 0.55 + beat * 0.12);
        const light = 60 + beat * 22;
        const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
        g.addColorStop(0, `hsla(${hue} 95% ${light}% / ${Math.min(1, 0.45 + v * 0.4 + beat * 0.25)})`);
        g.addColorStop(1, `hsla(${hue} 95% ${light}% / 0)`);
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, w, h);
      }
      if (beat > 0.05) { ctx.fillStyle = `rgba(255,255,255,${beat * 0.12})`; ctx.fillRect(0, 0, w, h); }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, [playing, mode]);
  return <canvas ref={ref} className={className} data-testid="now-playing-aurora" aria-hidden="true" />;
};
